import EditLocation from "./EditLocation";
import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import authContext from "../../../../AuthContext/authContext";
import Home from "../../Common/Home/Home";
import { useNavigate } from "react-router-dom";
const base_url = process.env.REACT_APP_BASE_URL;

const EditLocationWrapper = () => {
  const navigate = useNavigate();
  const activeEditLocationId = useSelector(
    (state) => state.appData.activeEditLocationId
  );
  const activeEditCompanyId = useSelector(
    (state) => state.appData.activeCompany._id
  );
  console.log(activeEditCompanyId, "activeEditCompanyId");
  const ctx = useContext(authContext);
  const token = ctx.token;
  const [initialData, setInitialData] = useState({});
  const [domLoaded, setDomLoaded] = useState(false);

  useEffect(() => {
    let reqObj = {
      method: "GET",
      url: `${base_url}/user/locationManager/List/${activeEditCompanyId}/${activeEditLocationId}`,
      headers: {
        "Content-Type": "application/javascript",
        Authorization: `Bearer ${token}`,
      },
    };

    axios(reqObj)
      .then((res) => {
        setInitialData({ ...res.data });
        setDomLoaded(true);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const onSuccess = () => {
    navigate('/location');
  };
  console.log(initialData, "initialData");
  return (
    <>
      <Home
        propComponent={domLoaded && <EditLocation initialData={initialData} onSuccess={onSuccess} />}
      />
    </>
  );
};

export default EditLocationWrapper;
